console.log('✅ utils-seos.js loaded successfully!'); // Debugging confirmation

export async function buildPageSEOTagsAsync(pageTranslateKey) {
  const { fetchPageSEOTagsAsync } = await import(
    /* webpackChunkName: "seo-data-service.js" */
    /* webpackPrefetch: true */
    '../services/data-services/seo-data-service.js'
  );

  const result = await fetchPageSEOTagsAsync(pageTranslateKey);

  return result;
}

export async function convertSEOResultToStringOnlyForHeader(result) {
  let resultString = '';

  if (!result) {
    console.warn('⚠️ No SEO result provided');
    return resultString;
  }

  const { metaTitle, metaDescription, metaKeywords, metaFollowIndexTag, pageSEOCanonical } = result;

  // Safely add meta tags
  if (metaTitle) resultString += `<title>${escapeHtml(metaTitle)}</title>`;
  if (metaDescription)
    resultString += `<meta name="description" content="${escapeHtml(metaDescription)}">`;
  if (metaKeywords) resultString += `<meta name="keywords" content="${escapeHtml(metaKeywords)}">`;
  if (metaFollowIndexTag)
    resultString += `<meta name="robots" content="${escapeHtml(metaFollowIndexTag)}">`;

  const canonicalHref = getCanonicalHref(pageSEOCanonical);
  if (canonicalHref) {
    resultString += `<meta property="og:title" content="${escapeHtml(metaTitle)}">`;
    resultString += `<meta property="og:description" content="${escapeHtml(metaDescription)}">`;
    resultString += `<meta property="og:url" content="${canonicalHref}">`;
    resultString += `<meta property="og:type" content="website">`;

    resultString += `<meta name="twitter:title" content="${escapeHtml(metaTitle)}">`;
    resultString += `<meta name="twitter:description" content="${escapeHtml(metaDescription)}">`;
    resultString += `<meta name="twitter:url" content="${canonicalHref}">`;

    //// Add canonical with hreflang="x-default" (optional, you can adjust this)
    resultString += `<link rel="canonical" href="${canonicalHref}" />`;
    //resultString += `<link rel="canonical" href="${canonicalHref}" hreflang="x-default" />`;
  }

  // Process alternate links with hreflang
  if (pageSEOCanonical) {
    const alternateLinks = pageSEOCanonical.match(/<link rel="alternate" [^>]+>/g);
    if (alternateLinks) {
      alternateLinks.forEach(link => {
        const hrefMatch = link.match(/href="([^"]+)"/);
        const hreflangMatch = link.match(/hreflang="([^"]+)"/);
        if (hrefMatch && hreflangMatch) {
          const href = hrefMatch[1];
          const hreflang = hreflangMatch[1];
          resultString += `<link rel="alternate" href="${href}" hreflang="${hreflang}" />`;
        }
      });
    }
  }

  return resultString;
}

// Extract canonical href from raw link tags
function getCanonicalHref(rawLinkTags) {
  if (!rawLinkTags) return '';
  const match = rawLinkTags.match(/<link rel="canonical" href="([^"]+)"\s*\/?>/);
  return match ? match[1] : '';
}

// Simple HTML escape utility
function escapeHtml(text) {
  if (!text) return '';
  return text.replace(/"/g, '&quot;');
}



const example = `
{
  "metaTitle": "Blog",
  "metaDescription": "A blog where you can find articles related to international commerce.",
  "metaKeywords": "",
  "metaFollowIndexTag": "noindex, nofollow",
  "pageSEOCanonical": "<link rel=\"canonical\" href=\"https://towobo.com/en/blog\" /><link rel=\"alternate\" hreflang=\"x-default\" href=\"https://towobo.com/en/blog\" /><link rel=\"alternate\" hreflang=\"en\" href=\"https://towobo.com/en/blog\" /><link rel=\"alternate\" hreflang=\"en-US\" href=\"https://towobo.com/us/blog\" /><link rel=\"alternate\" hreflang=\"fr\" href=\"https://towobo.com/fr/blog\" /><link rel=\"alternate\" hreflang=\"es\" href=\"https://towobo.com/es/blog\" /><link rel=\"alternate\" hreflang=\"de\" href=\"https://towobo.com/de/blog\" /><link rel=\"alternate\" hreflang=\"zh\" href=\"https://towobo.com/zh/博客\" /><link rel=\"alternate\" hreflang=\"it\" href=\"https://towobo.com/it/blog\" /><link rel=\"alternate\" hreflang=\"pt\" href=\"https://towobo.com/pt/blogue\" /><link rel=\"alternate\" hreflang=\"tr\" href=\"https://towobo.com/tr/blog\" /><link rel=\"alternate\" hreflang=\"ja\" href=\"https://towobo.com/ja/ブログ\" /><link rel=\"alternate\" hreflang=\"ko\" href=\"https://towobo.com/ko/블로그\" /><link rel=\"alternate\" hreflang=\"ar\" href=\"https://towobo.com/ar/مدونة\" />"
}
`;

export function Xample2(pageTranslateKey) {
  // return `working on it...`;

  return `<title>Find Quality Manufacturers and Suppliers from around the world on our online marketplace</title>
    <meta name="description" content="Find quality products from around the world and connect with global manufacturers &amp; wholesalers on our B2B eCommerce marketplace. Towobo allows manufacturers and wholesalers in countries around the world to list and sell their products globally.">
    <meta name="keywords" content="manufactures, wholesalers, exporters, importers, marketplace, suppliers, manufacturer, wholesaler, exporter, importer, supplier, quality, quality suppliers, quality manufacturers, quality wholesalers, quality exporters, quality importers, quality products, online marketplace, sell online, export, import">
    <meta name="robots" content="index, follow">

   <link rel="canonical" href="https://towobo.com/en/blog/6/hardware/41/honeywell-xnx-gas-detector-calibration-machine-price">
   <link rel="alternate" hreflang="x-default" href="https://towobo.com/en/blog/6/hardware/41/honeywell-xnx-gas-detector-calibration-machine-price">
   <link rel="alternate" hreflang="en" href="https://towobo.com/en/blog/6/hardware/41/honeywell-xnx-gas-detector-calibration-machine-price">
   <link rel="alternate" hreflang="en-us" href="https://towobo.com/us/blog/6/hardware/41/honeywell-xnx-gas-detector-calibration-machine-price">
   <link rel="alternate" hreflang="fr" href="https://towobo.com/fr/blog/6/matériel/41/honeywell-xnx-détecteur-de-gaz-calibrage-prix-de-la-machine">
   <link rel="alternate" hreflang="es" href="https://towobo.com/es/blog/6/hardware/41/precio-de-la-máquina-de-calibración-del-detector-de-gas-honeywell-xnx">
   <link rel="alternate" hreflang="de" href="https://towobo.com/de/blog/6/hardware/41/honeywell-xnx-gasdetektor-kalibrierungsmaschine-–-preis">
   <link rel="alternate" hreflang="zh" href="https://towobo.com/zh/博客/6/硬件/41/honeywell-xnx-气体检测仪校准机价格">
   <link rel="alternate" hreflang="it" href="https://towobo.com/it/blog/6/hardware/41/prezzo-della-macchina-calibrazione-rivelatore-gas-honeywell-xnx">
   <link rel="alternate" hreflang="pt" href="https://towobo.com/pt/blogue/6/hardware/41/honeywell-xnx-preço-da-máquina-de-calibração-detector-de-gás">
   <link rel="alternate" hreflang="tr" href="https://towobo.com/tr/blog/6/donanım/41/honeywell-xnx-gaz-dedektörü-kalibrasyon-makine-fiyatı">
   <link rel="alternate" hreflang="ja" href="https://towobo.com/ja/ブログ/6/ハードウェア/41/ハネウェル-xnx-ガス検知器校正機の価格">
   <link rel="alternate" hreflang="ko" href="https://towobo.com/ko/블로그/6/하드웨어/41/honeywell-xnx-가스-검지기-교정-기계-가격">
   <link rel="alternate" hreflang="ar" href="https://towobo.com/ar/مدونة/6/المعدات/41/سعر-جهاز-كشف-الغاز-هانيويل-xnx">
`;
}
